import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BuilderRightSideBar from "../../Layouts/BuilderRightSideBar";
import { useTreeContext } from "../../context/TreeDataContext";
import FormGridLayout from "../Form/FormGridLayout";
import RightSideFieldEditSection from "../Form/RightSideFieldEditSection";
import { getGridLayoutForDesktop } from "../../commonFunctions/formFunc";
import RDBMSFormSection from "../Form/RDBMSForm/RDBMSFormSection";
import { useFormContext } from "../../context/FormContext";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";

const RdbmsFormSection = () => {
  const { selectedForm, setSelectedForm } = useFormContext();
  // const {selectedRdbmsForm, setSelectedRdbmsForm} = useRdbmsFormContext();

  const { rdbmsFormId } = useParams();
  const { rdbmsFormsExplorerData } = useTreeContext();
  const navigate = useNavigate();

  const initialRendering = async () => {
    if (!rdbmsFormsExplorerData || !rdbmsFormId) return;
    const file = getFolderFileById(rdbmsFormsExplorerData, rdbmsFormId);
    if (file) {
      setSelectedForm({
        id: file.id,
        name: file.name,
        parentData: file.parentData,
        type: file.type
      });
    } else {
      navigate("../");
    }
  };

  useEffect(() => {
    initialRendering();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rdbmsFormId]);

  return (
    <div className="content_main_section">
      {selectedForm.id &&
        selectedForm.id === rdbmsFormId &&
        (() => {
          switch (selectedForm.type) {
            case "rdbmsform":
              return <RDBMSFormSection />;
            default:
              return <h1>No Block Found</h1>;
          }
        })()}
    </div>
  );
};

export default RdbmsFormSection;

const FormLayoutWithEdit = ({
  dragFromOutside,
  setDragFromOutside,
  from = "form",
  tableID = "",
  onChangeActiveMode
}) => {
  const [editFieldId, setEditFieldId] = useState({
    parent: null,
    id: null
  });
  const [editFieldData, setEditFieldData] = useState(null);
  const { renderFieldsData, formSectionsData, selectedSectionData, saveCurrentSectionInData } = useFormContext();
  const [activeMode, setActiveMode] = useState("edit");

  useEffect(() => {
    let data;
    if (editFieldId.parent) {
      const parentField = renderFieldsData.current[editFieldId.parent];
      const editIndex = parentField.components.findIndex((field) => field.id === editFieldId.id);
      // setEditFieldData(parentField.components[editIndex]);
      data = parentField.components[editIndex];
    } else {
      // setEditFieldData(renderFieldsData.current[editFieldId.id]);
      data = renderFieldsData.current[editFieldId.id];
    }

    //handling field_filters initialization(lookup) for old config
    if (data?.type === "lookup" && data?.field_filters === undefined) {
      data = {
        ...data,
        field_filters: [],
        field_filters_joined_by: ""
      };
    }
    setEditFieldData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editFieldId]);

  const handleChangeMode = (value) => {
    if (activeMode === "edit") {
      const currentField = saveCurrentSectionInData();
      const newDesktop = getGridLayoutForDesktop(
        currentField,
        formSectionsData.current[selectedSectionData].desktop_layout
      );
      const newMobile = getGridLayoutForDesktop(
        currentField,
        formSectionsData.current[selectedSectionData].mobile_layout
      );
      const newTablet = getGridLayoutForDesktop(
        currentField,
        formSectionsData.current[selectedSectionData].tablet_layout
      );
      formSectionsData.current[selectedSectionData].desktop_layout = newDesktop;
      formSectionsData.current[selectedSectionData].mobile_layout = newMobile;
      formSectionsData.current[selectedSectionData].tablet_layout = newTablet;
    }
    setActiveMode(value);
    onChangeActiveMode(value);
  };

  const modeOptions = [
    { name: <MaterialIcon name="edit" className="mode-options-icons" />, id: "edit" },
    { name: <MaterialIcon name="screenshot_monitor" className="mode-options-icons" />, id: "desktop" },
    { name: <MaterialIcon name="tablet_mac" className="mode-options-icons" />, id: "tablet" },
    { name: <MaterialIcon name="smartphone" className="mode-options-icons" />, id: "mobile" }
  ];

  const filteredModeOptions =
    from === "subform" ? modeOptions.filter((option) => option.id !== "desktop") : modeOptions;

  return (
    <div
      className={`form_section_outer form_section_droppable
        ${activeMode === "mobile" && "form_layout_in_mobile"} 
        ${activeMode === "tablet" && "form_layout_in_tablet"} 
        ${from === "sm" ? "sm_section_outer" : ""}`}
    >
      {(from === "form" || from === "subform") && (
        <div className="detailsView_items_top preview_icons_container">
          <div className="builder_form_icons_container">
            {/* <MultiRadio
            keyName="mode"
            options={modeOptions}
            selectedValue={activeMode}
            onChange={handleChangeMode}
            inputClassName="d_none"
          /> */}
            {filteredModeOptions.map((option) => (
              <div
                key={option.id}
                className={`mode-option ${activeMode === option.id ? "active" : ""}`}
                onClick={() => {
                  handleChangeMode(option.id);
                }}
              >
                {option.name}
              </div>
            ))}
          </div>
        </div>
      )}
      <div
        style={{
          width: activeMode === "mobile" ? "60%" : activeMode === "tablet" ? "80%" : "100%",
          height: "100%"
        }}
      >
        <FormGridLayout
          setEditFieldId={setEditFieldId}
          dragFromOutside={dragFromOutside}
          setDragFromOutside={setDragFromOutside}
          editFieldId={editFieldId}
          activeMode={activeMode}
          from="subform"
        />
      </div>
      <BuilderRightSideBar
        isOpen={editFieldId && editFieldId.id}
        onClose={() =>
          setEditFieldId({
            parent: null,
            id: null
          })
        }
        heading={`Edit  ${editFieldData?.type}`}
        size="medium"
      >
        <RightSideFieldEditSection
          editFieldId={editFieldId}
          setEditFieldId={setEditFieldId}
          tableID={tableID}
          editFieldData={editFieldData}
          setEditFieldData={setEditFieldData}
        />
      </BuilderRightSideBar>
    </div>
  );
};
export { FormLayoutWithEdit };
